import { Tag, Typography } from 'antd';
import { FallBackdata } from './types';
import { renderDescriptionForCompressors } from './Fallbacks.utils';
import { renderDescriptionWithStyledAnd } from './DescriptionRenderer';
import { StyledTable } from './styled';
import { useTranslation } from 'react-i18next';
import { EngineConfigStatus } from '@/store/Engine/constants';
import { Setpoint } from '@/store/Engine/common';

const { Title } = Typography;

interface FallbackDetailsProps {
  selectedFallback: FallBackdata | undefined;
  tableName: string;
  columns;
  currentTableData: Setpoint[];
  compressors;
  isDraftMode: boolean;
  fromVersionHistory: boolean;
  configurationStatus: EngineConfigStatus;
}

const FallbackDetails = ({
  selectedFallback,
  tableName,
  columns,
  currentTableData,
  compressors,
  isDraftMode,
  fromVersionHistory,
  configurationStatus,
}: FallbackDetailsProps) => {
  const { t } = useTranslation();

  if (!selectedFallback) {
    return null;
  }
  const shouldShowActiveBadge =
    !isDraftMode && !fromVersionHistory && configurationStatus !== EngineConfigStatus.Recommendation;

  return (
    <div className="details-container-fallback-two-point-o">
      <div className="details-header-fallback-two-point-o">
        <div className="details-content-fallback-two-point-o">
          <Title level={4} className="details-title-fallback-two-point-o">
            {selectedFallback.title}
          </Title>
          <div className="scenario-description-fallback-two-point-o">
            <div>
              <div className="scenario-label-fallback-two-point-o">
                {t('scenarioBasedOn')} {tableName}
              </div>
              <Typography.Paragraph className="scenario-label-fallback-two-point-o">
                {renderDescriptionWithStyledAnd(
                  renderDescriptionForCompressors(selectedFallback?.scenario, compressors, t),
                  t('AND'),
                )}
              </Typography.Paragraph>
            </div>
          </div>
        </div>

        {selectedFallback.active && shouldShowActiveBadge && (
          <Tag className="active-badge-fallback-two-point-o">
            <div className="icon">!</div>
            {t('currentlyActive')}
          </Tag>
        )}
      </div>
      <div className="scenario-divider-fallback-two-point-o"></div>

      <StyledTable
        columns={columns}
        dataSource={currentTableData}
        pagination={false}
        bordered
        size="small"
        rowKey="key"
      />
    </div>
  );
};

export default FallbackDetails;
